import { DeliveryFormSchema, DeliveryStatusSchema } from "../types/delivery";
import { BookingFormValues } from "../types/overview";
import { apis } from "service";
import { AxiosRequestConfig } from "axios";
import { CapturePaymentFormValues, PaymentStatusRequest } from "../types/payment";
import { OrderDetailResponse } from "../types/order";
import { ApproveDocumentReqType, RequestDocumenReqType, RequploadDocumentReqType, UpdateSingleProductReqType, UpdateTCSReqType } from "../types/type.api";
import { da } from "date-fns/locale";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const update_product_status = BASE_URL + 'FiAQK2sE/accept_reject_product_v3'
const capture_payment = BASE_URL + 'FiAQK2sE/addPayment'
const update_payment = BASE_URL + 'FiAQK2sE/updatePayment'
const get_order_details = BASE_URL + 'M4Re3bq8/order_details_v3'
const add_delivery_address = BASE_URL + 'FiAQK2sE/addDelivery'
const update_delivery_address = BASE_URL + 'FiAQK2sE/edit_address_v3_0'
const update_payment_status = BASE_URL + 'FiAQK2sE/payment_status'
const update_delivery_status = BASE_URL + 'FiAQK2sE/update_delivery_status'
const update_notes = BASE_URL + 'FiAQK2sE/edit_order_note'
const approve_documents = BASE_URL + 'FiAQK2sE/approve_reject_doc'
const tcs_update = BASE_URL + 'M4Re3bq8/EditOrderDetail'
const update_product = BASE_URL + 'FiAQK2sE/edit_product_detail_v3'
const request_document = BASE_URL + 'FiAQK2sE/req_doc'
const reupload_document = BASE_URL + 'FiAQK2sE/reupload_doc_v3'

type StatusWithoutName = Omit<BookingFormValues["status"][number], "name">;

type BookingFormPayload = {
    order_id: number;
    status: StatusWithoutName[];
};


export const updateProducts = async (data: BookingFormPayload) => {
  const payload: AxiosRequestConfig = {
    data
  }
  // use axios
  return await apis.post(update_product_status, payload)
};

export const capturePayment = async (data: CapturePaymentFormValues) => {
  const formData = new FormData();
  formData.append("order_details_id", data.order_details_id.toString());
  formData.append("ack_no", data.ack_no);
  formData.append("amount", data.amount.toString());
  formData.append("Payment_Proof", data.Payment_Proof);

  if (data.Supporting_document) {
    formData.append("Supporting_document", data.Supporting_document);
  }

  const payload: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };

  return await apis.post(capture_payment, payload);
}

export const updatePayment = async (data: CapturePaymentFormValues) => {

  const payload: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  return await apis.post(update_payment, payload);
}

export const getOrderDetails = async (orderId: string): Promise<OrderDetailResponse> => {
  const payload: AxiosRequestConfig = {
    params: {
      order_details_id: orderId,
    },
  };

  const response = await apis.get(get_order_details, payload);
  return response.data as OrderDetailResponse;
}

export const addDeliveryAddress = async (id: string, data: DeliveryFormSchema[]) => {
  const dataToSend = {
    'delivery_detail': data.map((delivery) => {
      return {
        "order_details_id": id,
        "house_number": delivery.address1,
        "street_number": delivery?.address2,
        "City": delivery.city,
        "country": delivery.country,
        "landmark": delivery.landmark,
        "State": delivery.state,
        "pincode": delivery.pincode,
        "delivered_by": delivery.delivery_channel,
        "delivery_mode": delivery.delivery_mode,
        "delivery_id": delivery.delivery_id,
        "product_id": delivery.products,
        "customers_id": delivery.customers,
        'address_id': delivery.address_id || ''
      }
    })
  }
  const payload: AxiosRequestConfig = {
    data: dataToSend,
  }
  // use axios
  return await apis.post(add_delivery_address, payload)
}

export const updateDeliveryAddress = async (id: string, data: (DeliveryFormSchema & {uuid:string})) => {

  const dataToSend = {
    "house_number": data?.address1,
    "street_number": data?.address2,
    "City": data?.city,
    "country": data?.country,
    "landmark": data?.landmark,
    "State": data?.state,
    "pincode": data?.pincode,
    "address_id": data?.address_id,
    "generic_order_details_id": id,
    "delivery_mode": data?.delivery_mode,
    "delivery_id": data?.delivery_id,
    "generic_delivery_id": data?.uuid
  }
  const payload: AxiosRequestConfig = {
    data: dataToSend,
  }
  // use axios
  return await apis.post(update_delivery_address, payload)
}

export const updatePaymentStatus = async (data: PaymentStatusRequest) => {
  const payload: AxiosRequestConfig = {
    data
  }
  return await apis.post(update_payment_status, payload)
}

export const updateDeliveryStatus = async (order_id: string, delivery_id: string, data: DeliveryStatusSchema) => {
  const dataToSend = {
    "order_details_id": order_id,
    "status_update": {
      "delivery_id": delivery_id,
      "status": data.status,
      "date": data.date,
      "quantity" : data.quantity
    }
  }
  const payload: AxiosRequestConfig = {
    data: dataToSend
  }
  return await apis.post(update_delivery_status, payload)
}

export const updateNotes = async ({ order_id, notes }: { order_id: string, notes: string }) => {
  const data = {
    "order_details_id": order_id,
    "notes": notes
  }
  const payload: AxiosRequestConfig = {
    data
  }
  return await apis.post(update_notes, payload)
}

export const approveDocuments = async (data: ApproveDocumentReqType) => {
  const payload: AxiosRequestConfig<ApproveDocumentReqType> = {
    data
  }
  return await apis.post(approve_documents, payload)
}

export const updateTcs = async (data: UpdateTCSReqType) => {
  const payload: AxiosRequestConfig<UpdateTCSReqType> = {
    data: data
  }
  return await apis.patch(tcs_update, payload)
}

export const updateProductSingle = async (data: UpdateSingleProductReqType): Promise<any> => {
  const payload: AxiosRequestConfig<UpdateSingleProductReqType> = {
    data: data
  }
  return await apis.patch(update_product, payload)
}

export const requestDocument = async (data: RequestDocumenReqType): Promise<any> => {
  const payload: AxiosRequestConfig<RequestDocumenReqType> = {
    data: data
  }
  return await apis.post(request_document, payload)
}

export const reuploadDocument = async (data: RequploadDocumentReqType): Promise<any> => {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (key === 'doc') {
        formData.append(key, value as string); // Assuming value is a Base64URLString
      } else {
        formData.append(key, value.toString());
      }
    }
  });

  const payload: AxiosRequestConfig<FormData> = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };

  return await apis.post(reupload_document, payload);
}